import React from 'react';

import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';

import TextField from '@mui/material/TextField';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import DropZone from 'components/Shared/DropZone';
import PieceGestionSearch from 'components/Shared/PieceGestionSearch';
import LigneGestionQualification from 'components/Shared/LigneGestionQualification';
import DepannageDirectClient from 'components/Shared/DepannageDirectClient';
import ColisLogistiquePhoto from 'components/Shared/ColisLogistiquePhoto';

import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';
import { AnomalieType } from 'constants.js';
import { TypeCodes } from 'constants.js';

const styles = {
    flexContainer: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    row: {
        flexBasis: '100%',
        marginBottom: '10px'
    }
};


/* Liste des réponses possibles */
const photoConsulteeLabel = "Avez-vous pris connaissance de la photo ? ";
const photoConsulteeLabels = [
    "Oui, j'ai trouvé les informations souhaitées et tout est conforme (dossier après-vente clôturé automatiquement).",
    "Oui, mais je souhaite créer le dossier après-vente"
];

const Etape = {
    ChoixDeLaPiece: 0,
    Qualifications: 1
};

class DefautProduitAspectDeballageStep extends React.Component {
    state = {
        expandedPanel: 'panelPiece',
        etape: Etape.ChoixDeLaPiece
    };

    componentDidMount() {
        // On détermine si on doit rendre accessible le bouton pour passer à l'étape suivante ou le bouton de création.
        const { reclamation, onNextStepValid } = this.props;

        const nextStepValid = reclamation.numeroPiece.length > 0 && reclamation.lignes.length > 0;

        onNextStepValid(nextStepValid);
    }


    // Obtention d'un détail quelconque.
    getDetail(code, typeValeur) {
        const { reclamation } = this.props;

        // Initialisation de la valeur
        let valeur = '';

        // Obtention du code
        const detail = reclamation.qualificationDetails.find(detail => detail.code === code);

        // Affectation si possible de la valeur en fonction du type demandé
        if (detail !== undefined) {
            valeur = detail[typeValeur];
        }

        return valeur;
    }


    getPhotoConsultee() {
        return this.getDetail(ReclamationQualificationDetailCodes.PhotoConsultee, 'valeurInteger');
    }

    getDepannageDirectClient() {
        return this.getDetail(ReclamationQualificationDetailCodes.DepannageDirectClient, 'valeurBool');
    }

    checkErrors(depannageDirectClient, photoConsultee, fichiersIds) {
        const { reclamation, utilisateurMagasin, colisLogistiques } = this.props;

        const fichiersIdsToCheck = fichiersIds !== null ? fichiersIds : reclamation.fichiersIds;

        let errors = [];

        if (reclamation.type.code === TypeCodes.Client && utilisateurMagasin) {
            if (depannageDirectClient === '') {
                errors.push({ key: ReclamationQualificationDetailCodes.DepannageDirectClient, errorMsg: 'Avez-vous résolu le problème de votre client ?' });
            } else {
                errors.push({ key: ReclamationQualificationDetailCodes.DepannageDirectClient, errorMsg: null });
            }
        }

        if (reclamation.numeroPiece.length === 0) {
            errors.push({ key: ReclamationQualificationDetailCodes.Piece, errorMsg: 'Veuillez sélectionner une pièce.' });
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.Piece, errorMsg: null });
        }

        if (reclamation.lignes.length === 0) {
            errors.push({ key: ReclamationQualificationDetailCodes.NbLignes, errorMsg: 'Au moins une ligne doit être renseignée.' });
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.NbLignes, errorMsg: null });
        }
        
        if (!fichiersIdsToCheck || fichiersIdsToCheck.length === 0) {
            errors.push({ key: "PIECE_JOINTE_OBLIGATOIRE", errorMsg: "Veuillez ajouter une ou plusieurs photos du produit abimé en pieces jointes." });
        } else {
            errors.push({ key: "PIECE_JOINTE_OBLIGATOIRE", errorMsg: null });
        }        

        if (colisLogistiques.length > 0) {

            let reclaCodes = reclamation.lignes.map(x => x.codeArticle);

            let colisLogistiquesPhoto = colisLogistiques.map(x => {

                let codesArticles = x.lignes.map(x => x.codeArticle);
                let c = {
                    photoId: x.photoId,
                    numeroSupport: x.numeroSupport,
                    concerneRecla: reclaCodes.some(r => codesArticles.indexOf(r) >= 0)
                };
                return c;
            });

            let afficherQuestion = colisLogistiquesPhoto.some(x => x.concerneRecla && x.photoId);

            //console.log("reclaCodes", reclaCodes);
            //console.log("colisLogistiquesPhoto", colisLogistiquesPhoto);
            //console.log("afficherQuestion", afficherQuestion);
            //console.log("photoConsultee", photoConsultee);

            if (afficherQuestion) {
                if (photoConsultee === '') {
                    errors.push({ key: ReclamationQualificationDetailCodes.PhotoConsultee, errorMsg: photoConsulteeLabel });
                } else {
                    errors.push({ key: ReclamationQualificationDetailCodes.PhotoConsultee, errorMsg: null });
                }
            } else {
                errors.push({ key: ReclamationQualificationDetailCodes.PhotoConsultee, errorMsg: null });
            }
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.PhotoConsultee, errorMsg: null });
        }


        return errors;
    }

    handleChangePanel = panel => (event, expandedPanel) => {
        this.setState({
            expandedPanel: expandedPanel ? panel : false
        });
    }

    handleChange = (event) => {
        const { onChange } = this.props;

        const errors = this.checkErrors(this.getDepannageDirectClient(), this.getPhotoConsultee(), null);

        onChange(event, errors);
    }

    handleChangePhoto = (event) => {
        const { onChange } = this.props;
        
        console.log("handleChangePhoto newFichiersIds", event.target.value);

        const errors = this.checkErrors(this.getDepannageDirectClient(), this.getPhotoConsultee(), event.target.value);    

        onChange(event, errors);
    }

    handleSelectPiece = (value) => {
        const { onSelectPiece } = this.props;

        // On ouvre le panel avec les lignes de la pièce.
        this.setState({
            expandedPanel: 'panelLignes',
            etape: Etape.Qualifications
        });

        const errors = this.checkErrors(this.getDepannageDirectClient(), this.getPhotoConsultee(), null);

        onSelectPiece(value, errors);
    }

    handleQualificationDetailsPhotoConsulteeChange = (event) => {
        const { onDetailChange } = this.props;

        const qualificationDetail = {
            position: 0,
            code: ReclamationQualificationDetailCodes.PhotoConsultee,
            type: ReclamationQualificationDetailType.ChoixSimple,
            libelle: photoConsulteeLabel,
            valeurString: photoConsulteeLabels[event.target.value],
            valeurInteger: parseInt(event.target.value, 10)
        };

        const errors = this.checkErrors(this.getDepannageDirectClient(), event.target.value, null);

        onDetailChange(qualificationDetail, errors, null);
    }

    handleQualificationDetailsDepannageDirectClientChange = (event) => {
        const { onDetailChange } = this.props;

        const qualificationDetail = {
            position: 1,
            code: ReclamationQualificationDetailCodes.DepannageDirectClient,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: 'Avez-vous résolu le problème de votre client ?',
            valeurBool: event.target.value
        };

        const errors = this.checkErrors(event.target.value, this.getPhotoConsultee(), null);

        onDetailChange(qualificationDetail, errors, null);
    }


    handleAddLigne = (ligne) => {
        const { onAddLigne } = this.props;

        const errors = this.checkErrors(this.getDepannageDirectClient(), this.getPhotoConsultee(), null);

        onAddLigne(ligne, errors);
    }

    handleRemoveLigne = (numeroLigne) => {
        const { onRemoveLigne } = this.props;

        const errors = this.checkErrors(this.getDepannageDirectClient(), this.getPhotoConsultee(), null);

        onRemoveLigne(numeroLigne, errors);
    }

    renderPriseConnaissancePhoto() {
        const { classes, reclamation, colisLogistiques } = this.props;

        const photoConsulteeValue = this.getPhotoConsultee();

        let reclaCodes = reclamation.lignes.map(x => x.codeArticle);



        let colisLogistiquesPhoto = colisLogistiques.map(x => {

            let codesArticles = x.lignes.map(x => x.codeArticle);
            let c = {
                photoId: x.photoId,
                numeroSupport: x.numeroSupport,
                concerneRecla: reclaCodes.some(r => codesArticles.indexOf(r) >= 0)
            };
            return c;
        });

        // console.log("colisLogistiquesPhoto", colisLogistiquesPhoto);

        let afficherQuestion = colisLogistiquesPhoto.some(x => x.concerneRecla && x.photoId);

        return (

            <>

                {afficherQuestion && (
                    <>

                        <div className={classes.row}>

                            <FormControl required className={classes.formControl}>
                                <FormLabel component="legend" sx={{ display: 'flex' }}>
                                    {photoConsulteeLabel}

                                    {colisLogistiquesPhoto.map((colis, index) => {
                                        return (
                                            <ColisLogistiquePhoto
                                                key={index}
                                                colis={colis}
                                                disabledMessage={!colis.photoId ? "pas de photo de ce colis" : !colis.concerneRecla ? "colis non concerné" : ""}
                                                mode={"button"}
                                                size={"large"}
                                            />
                                        );
                                    })}

                                </FormLabel>
                                <RadioGroup
                                    id={ReclamationQualificationDetailCodes.PhotoConsultee}
                                    name={ReclamationQualificationDetailCodes.PhotoConsultee}
                                    className={classes.group}
                                    value={photoConsulteeValue}
                                    onChange={this.handleQualificationDetailsPhotoConsulteeChange}>
                                    {photoConsulteeLabels.map((reponse, index) => (
                                        <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                                    ))}
                                </RadioGroup>
                            </FormControl>

                        </div>

                    </>
                )}
            </>


        );

    }

    renderDepannageDirectClient() {
        const { reclamation, utilisateurMagasin } = this.props;

        const detailDepannageDirectClientValue = this.getDepannageDirectClient();

        if (reclamation.type.code === TypeCodes.Client && utilisateurMagasin) {
            return (<DepannageDirectClient
                onDetailChange={this.handleQualificationDetailsDepannageDirectClientChange}
                value={detailDepannageDirectClientValue}
            />
            );
        } else {
            return null;
        }
    }

    render() {
        const { classes, reclamation, namespace } = this.props;
        const { etape, expandedPanel } = this.state;

        return (
            <React.Fragment>

                <div className={classes.row}>
                    <TextField
                        multiline
                        fullWidth
                        name="commentaire"
                        label="Commentaire"
                        placeholder="Décrire le problème rencontré"
                        maxRows="3"
                        onChange={this.handleChange}
                        value={reclamation.commentaire}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </div>

                <div className={classes.row}>
                    <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChangePhoto} />
                </div>

                <div className={classes.row}>
                    <Accordion expanded={expandedPanel === 'panelPiece'} onChange={this.handleChangePanel('panelPiece')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className={classes.panelSummary}
                        >
                            <Typography >Rechercher une pièce* (obligatoire pour accéder aux lignes)</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <PieceGestionSearch
                                onSelectPiece={this.handleSelectPiece}
                                client={reclamation.client}
                                withLignes
                                namespace={namespace}
                                warningReclamation
                                defautProduitInfos={false}
                                logistiqueInfos={false}
                                defautNumeroPiece={reclamation.numeroPiece}
                            />
                        </AccordionDetails>
                    </Accordion>
                </div>


                {reclamation.numeroPiece && etape === Etape.Qualifications && (
                    <>
                        <div className={classes.row}>
                            <Accordion expanded={expandedPanel === 'panelLignes'} onChange={this.handleChangePanel('panelLignes')}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    className={classes.panelSummary}
                                >
                                    <Typography >Sélectionner une ligne* (au moins une ligne en anomalie pour pouvoir créer le dossier après-vente)</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className={classes.row}>
                                        <LigneGestionQualification
                                            reclamation={reclamation}
                                            onAddLigne={this.handleAddLigne}
                                            onRemoveLigne={this.handleRemoveLigne}
                                            typeAnomalie={AnomalieType.DefautProduitAspectDeballage}
                                            disableCompose
                                            namespace={namespace}
                                            afficherQuantiteRetournable
                                        />

                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        </div>


                        <div className={classes.row}>
                            {this.renderPriseConnaissancePhoto()}
                        </div>

                        <div className={classes.row}>
                            {this.renderDepannageDirectClient()}
                        </div>
                    </>
                )}




            </React.Fragment>
        );
    }
}

DefautProduitAspectDeballageStep.propTypes = {
    reclamation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onDetailChange: PropTypes.func.isRequired,
    onSelectPiece: PropTypes.func.isRequired,
    onAddLigne: PropTypes.func.isRequired,
    onRemoveLigne: PropTypes.func.isRequired,
    validationErrors: PropTypes.array.isRequired,
    onNextStepValid: PropTypes.func.isRequired,
    namespace: PropTypes.string.isRequired
};

export default withStyles(styles)(DefautProduitAspectDeballageStep);